import { EColumnDataType } from '@components/table';
import React, { ReactElement, ReactNode } from 'react';

export type TableColProps = {
  header?: string | ReactElement;
  name: string;
  type?: EColumnDataType;
  fixedPosition?: 'left' | 'right';
  sortable?: boolean;
  align?: 'left' | 'right' | 'center';
  width?: number;
  children?: ReactNode;
  disableClickAction?: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SwyftTableCol = (props: TableColProps): JSX.Element => <div />;
